import { LOCAL_STORAGE_KEYS } from "src/utils/localStorageKeys"


export const removeAuthTokens = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH.ACCESS_TOKEN)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH.REFRESH_TOKEN)
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER.INFO)
}

export const addAuthTokens = (data: any) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH.ACCESS_TOKEN, data.access)
  localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH.REFRESH_TOKEN, data.refresh)
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER.INFO, JSON.stringify(data.user))
}
